
import $ from 'jquery';
import 'jquery.cookie';
import 'slick-carousel'


import 'vite/modulepreload-polyfill'
import './tailwind.css'
import './core.scss'
import './tailwind.css'
import './scripts/footer.js'

// Ensure jQuery is available globally
window.$ = window.jQuery = $;
